import api from './api';

export default async function getActiveTemplate(task_type_id) {
  const { data } = await api.get(`arc-automarker/templates/${task_type_id}`);
  return data;
}